export default "__VITE_ASSET__FsvYr9im__"